/**
 * "approve_tool_call" → "Approve Tool Call"
 * Used as a fallback when an interrupt doesn't carry an explicit `title`.
 * Producers that want clean headers should set `title` directly; this is
 * just a graceful default.
 */
export function humanizeAction(action: string): string {
  return action
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

/**
 * "field_name" → "Field name". Used by Args' default row renderer.
 */
export function humanizeKey(key: string): string {
  if (!key) return key;
  const spaced = key.replace(/[_-]+/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2");
  return spaced.charAt(0).toUpperCase() + spaced.slice(1).toLowerCase();
}
